import React, { Component } from "react";
import { Spin, Modal, Row, Col, Button, Descriptions, Pagination } from "antd";
import { history } from "../../../helpers";
import DoctorsView from "./DoctorsView";

import { getClinicList } from "../../../services";

export default class DoctorsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAddDoctorModal: false,
      openFoundDoctorModal: false
    };
  }

  toggleAddDoctorModal = () => {
    this.setState({
      openAddDoctorModal: !this.state.openAddDoctorModal
    });
  };
  toggleFoundDoctorModal = () => {
    this.setState({
      openFoundDoctorModal: !this.state.openFoundDoctorModal
    });
  };

  /**
   * @function  navigateToDoctorDetails
   * @description This function redirect the user to doctor-details
   */
  navigateToDoctorDetails = record => {
    const { details } = this.props;

    history.push(
      `/doctor-details/${record.doctor.id}/basic-details/${details.id}/${record.id}`
    );
  };

  render() {
    const { details, getClinicInfo } = this.props;
    const { openAddDoctorModal, openFoundDoctorModal } = this.state;
    return (
      <>
        {details && (
          <DoctorsView
            openAddDoctorModal={openAddDoctorModal}
            openFoundDoctorModal={openFoundDoctorModal}
            toggleAddDoctorModal={this.toggleAddDoctorModal}
            toggleFoundDoctorModal={this.toggleFoundDoctorModal}
            details={details}
            navigateToDoctorDetails={this.navigateToDoctorDetails}
            getDoctorsListData={getClinicInfo}
          />
        )}
      </>
    );
  }
}
